import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container, Title, Description, Teacher, Meetings, BoxButtons, Message, ListItem, Legend, IconBox, Justify, Documents, InfoSubs, InfoSubsTitle, DocumentsMABox, DocumentDeleteButton, ConfirmFile, Module } from "./styles";
import { format, isAfter, isBefore, isWithinInterval} from "date-fns";
import {
  MdArrowDropUp,
  MdArrowDropDown,
} from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import { BsTrash } from "react-icons/bs";
import ptBR from "date-fns/esm/locale/pt-BR/";
import Accessibility from "../../../components/UI/Accessibility";
import Menu from "../../../components/UI/Menu";
import ContentBox from "../../../components/UI/ContentBox";
import Footer from "../../../components/UI/Footer";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import { images } from "../../../constants";
import Banner from "../../../components/UI/Banner";
import Visibility from "../../../components/UI/Visibility";
import ellipsis from "../../../utils/ellipsis";
import { v4 as uuidv4 } from "uuid";
import filesize from "filesize";

import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";

import CancelButton from "../../../components/UI/CancelButton";
import ReadMoreButton from "../../../components/UI/ReadMoreButton";
import InputFile from "../../../components/UI/Inputs/InputFile";
import Modal from "../../../components/UI/Modal"
// import * as XLSX from "xlsx";
import { icons } from "../../../constants";
import textToVectorIsLink from "../../../utils/textToVectorIsLink";

import QRCode from "./Components/QRCode";

const CoursesView = () => {
  const { user } = useAuth();

  const { id } = useParams();

  const navigate = useNavigate();

  const [documento, setDocumento] = useState({});
  // const [listInfoSubscribe, setListInfoSubscribe] = useState([]);
  const [activities, setActivities] = useState([]);
  const [listUserActivities, setListUserActivities] = useState([]);
  const [listJustify, setListJustify] = useState([]);
  const [listModule, setListModule] = useState([]);
  const [openModule, setOpenModule] = useState(null);

  const [subscriptionText, setSubscriptionText] = useState("");
  const [workload, setWorkload] = useState(0);
  const [abonadas, setAbonadas] = useState(0);

  const [ModalOpenAlert, setModalOpenAlert] = useState(false);
  const [ModalOpenUnsubscribe, setModalOpenUnsubscribe] = useState(false);

  const [ModalOpenAlertUnsubscribe, setModalOpenAlertUnsubscribe] = useState(false);
  const [unsubscriptionStatusMessage, setModalOpenUnsubscriptionStatusMessage] = useState("");

  const [ModalDeleteFile, setModalDeleteFile] = useState({open:false,type:"",file:""});

  const [activitiesRights, setActivitiesRights] = useState({tutor:false,editor:false,inscrito:false,load:false});
  const [activityOpen, setActivityOpen] = useState(false);

  const [modalMessage, setModalMessage] = useState({open:false,text:""});

  const [modalSendFile, setModalSendFile] = useState({open:false,type:"",data:{event:{},idContentActivity:"",update:false}});

  const [modalQRRegistro, setModalQRRegistro] = useState("");

  const handleModalAlertUnsubscribe = () => {
    setModalOpenAlertUnsubscribe((oldModalOpenAlertUnsubscribe) => !oldModalOpenAlertUnsubscribe);
  };

  const handleAlertUnsubscribeOk = () => {
    if(unsubscriptionStatusMessage==="Inscrição cancelada com sucesso!"){
      navigate("/formacoes");
    }
    else{
      handleModalAlertUnsubscribe();
    }
  };

  const handleModalAlert = () => {
    setModalOpenAlert((oldModalOpenAlert) => !oldModalOpenAlert);
  };

  const handleModalUnsubscribe = () => {
    // console.log("ModalOpenUnsubscribe",ModalOpenUnsubscribe);
    setModalOpenUnsubscribe((oldModalOpenUnsubscribe) => !oldModalOpenUnsubscribe);
  };

  const isEditor = () => {
    let editor = user?.profiles[0]?.editor?.findIndex(
      (editor) => editor.id === "0e3b686a-9b75-4de0-a2b7-28ec578e8119"
    );
    return editor > -1 ? true : false;
  };

  const isDeped = () => {
    return user?.profiles[0]?.idProfile === "b56d58fe-2377-4428-854d-5f20670fb166";
  };

  const getHourActivity = (hour) => {
    return `${Math.trunc(hour)}:${(hour-Math.trunc(hour))*60<10?0:""}${(hour-Math.trunc(hour))*60}`
  }

  const [loadDocument, loadDocumentInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("Documento formação", response);
        if(response.data.length>0){
          console.log("Documento formação", response.data[0]);
          setDocumento(response.data[0]);
        }
        else{
          if(user){
            console.log("não carregou dados da formação");
            navigate("/formacoes");
          }
          else{
            navigate(`/login/redirect/*formacoes*${id}`)
          }
        }
      }
    },
  });

  const [loadRights, loadRightsInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/activities/coursesByUser",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("course by user", response.data[0]);
        if(response.data.length>0){
          setActivitiesRights({tutor:response.data[0].isTutor,editor:response.data[0].isEditor,inscrito:response.data[0].isRegistered,load:true});
        }
      }
    },
    onError:(error)=>{
      console.log("error", error);
    },
  });

  const [unsubscribe, UnsubscribeInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/subscription",
    method: "delete",
    onCompleted: (response) => {
      handleModalUnsubscribe();
      handleModalAlertUnsubscribe();
      if (!response.error) {
        setModalOpenUnsubscriptionStatusMessage("Inscrição cancelada com sucesso! Verifique a confirmação no seu e-mail!")
        // alert("Desinscrito com sucesso");
        // window.location.reload();
        // console.log("deletou", response);
      }
      else{
        setModalOpenUnsubscriptionStatusMessage("Erro ao cancelar a inscrição, tente novamente!")
      }
    },
  });

  const [deleteFile, deleteFileInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/media",
    method: "delete",
    onCompleted: (response) => {
      if (!response.error) {
        loadListUserActivities({
          params:{
            idContent:id,
            idUserSubscription:documento.idUserSubscription,
          }
        });
        setModalMessage({open:true,text:"Arquivo deletado com sucesso!"})
      }
      else{
        setModalMessage({open:true,text:"Erro ao deletar o arquivo tente novamente"})
      }
    },
      onError: (error)=>{
      setModalMessage({open:true,text:"Erro ao deletar o arquivo tente novamente"})
      console.log("error",error);
    },
  });

  // const [listSubscribe, ListSubscribeInfo] = useApi({
  //   debounceDelay: 0,
  //   url: "canalPedagogico/course/subscription",
  //   method: "get",
  //   onCompleted: (response) => {
  //     if (!response.error) {
  //       console.log("listSubscribe", response.data);
  //       setListInfoSubscribe(response.data);
  //     }
  //   },
  //   onError:(error)=>{
  //     console.log("error", error);
  //   },
  // });

  const [listActivities, ListActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/activities",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listActivities", response.data);
        setActivities(response.data);
        console.log("entrou");
        let tempModule = [];
        response.data.forEach((activity)=>{
          if((tempModule.filter((module)=>{return module===activity.module}).length===0)&&(isAfter(new Date(parseInt(activity.activityBegin)),new Date())===false)){
            tempModule.push(activity.module);
          }
        })
        setListModule(tempModule);
        if(tempModule.length===1){
          setOpenModule(tempModule[0]);
        }
      }
    },
    onError:(error)=>{
      console.log("error", error);
    },
  });

  const [loadListUserActivities, LoadListUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/course",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listUserActivities teste", response.data);
        let tempList = [];
        let tempWork = 0;
        let tempAbonadas = 0;
        activities.forEach((activity)=>{
          let userActivity = response.data.find((userAct)=>{
            return userAct.idcontent_activity === activity.idContentActivity;
          });
          if(userActivity?.hours_taken===1){
            console.log("teste");
            console.log("userActivity.activity_score",userActivity.activity_score);
            if(userActivity?.activity_score){
              tempWork+=userActivity?.activity_score;
            }
          }
          if(userActivity?.hours_taken===2){
            tempAbonadas+=activity.activityWorkload;
          }
          tempList.push({
            ...activity,
            idactivities_justifications:userActivity?.idactivities_justifications,
            hours_taken:userActivity?.hours_taken,
            userActivity:{...userActivity},
          })
        });
        console.log("listUsrActivities",tempList);
        setAbonadas(tempAbonadas);
        setWorkload(tempWork);
        setListUserActivities(tempList);
      }
    },
    onError: (error)=>{ 
      console.log("listUserActivities error", error);
      // document.location.reload(false);
    },
  });

  const [getListJustify, getListJustifyInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/activitiesJustifications",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listJustify", response.data);
        setListJustify(response.data);
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [saveItemCDN, saveItemCDNInfo] = useApi({
    debounceDelay: 0,
    baseURL: process.env.REACT_APP_CDN_API,
    multi: true,
    url: "canalPedagogico/course/userActivities/media",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        loadListUserActivities({
          params:{
            idContent:id,
            idUserSubscription:documento.idUserSubscription,
          }
        });
        setModalMessage({open:true,text:"Arquivo enviado com sucesso!"})
      }
    },
      onError: (error)=>{
      setModalMessage({open:true,text:"Erro ao enviar o arquivo tente novamente"})
      console.log("error",error);
    },
  });

  const [updateItemCDN, updateItemCDNInfo] = useApi({
    debounceDelay: 0,
    baseURL: process.env.REACT_APP_CDN_API,
    multi: true,
    url: "canalPedagogico/course/userActivities/media",
    method: "put",
    onCompleted: (response) => {
      if (!response.error) {
        loadListUserActivities({
          params:{
            idContent:id,
            idUserSubscription:documento.idUserSubscription,
          }
        });
        setModalMessage({open:true,text:"Arquivo enviado com sucesso!"})
      }
    },
      onError: (error)=>{
      setModalMessage({open:true,text:"Erro ao enviar o arquivo tente novamente"})
      console.log("error",error);
    },
  });

  const handleUnsubscribe = () => {
      // console.log("desinscreveu", id);
      if(documento.idUserSubscription){
        unsubscribe({
          data: {
            id:documento.idUserSubscription,
          },
        });
      }
  };

  const handleSubscription = () => {
    if(subscriptionText === "Fazer inscrição"){
      navigate(`/inscricaoformacoes/${id}`);  
    }
    if(subscriptionText === "Inscrição indisponível"){
      handleModalAlert();
    }
    if(subscriptionText === "Excluir inscrição"){
      if(documento.idUserSubscription){
        handleModalUnsubscribe();
      }
    }
  };

  /* Begin Controle de envio de arquivos */

  const handleAttachFilesPortfolio = (file,idContentActivity,update=false) => {
    // console.log(idContentActivity);
    // const file = event.target.files[0];
    let form = new FormData();
    form.append("idContentActivity", idContentActivity );
    form.append("file", file);
    if(update){
      updateItemCDN({
        data:form,
      });
    }else{
      saveItemCDN({
        data:form,
      });
    }
  };

  const handleAttachFilesJustificativa = (file,idContentActivity,update=false) => {
    // console.log(idContentActivity);
    // const file = event.target.files[0];
    let form = new FormData();
    form.append("idContentActivity", idContentActivity );
    form.append("file", file);
    form.append("isJustification", true);
    if(update){
      updateItemCDN({
        data:form,
      });
    }else{
      saveItemCDN({
        data:form,
      });
    }
  };

  /* Begin Controle de envio de arquivos */


  useEffect(() => {
    if(activitiesRights.load && documento.idUserSubscription){
      if (activitiesRights.inscrito||activitiesRights.tutor||activitiesRights.editor){      
        console.log("carregar atividades");
        listActivities({
          params: {
            idContent:id,
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [activitiesRights,documento]);

  useEffect(() => {
    if(activities.length>0){
      console.log("carregou atividades");
      if(documento.idUserSubscription){
        loadListUserActivities({
          params:{
            idContent:id,
            idUserSubscription:documento.idUserSubscription,
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [activities,documento]);

  useEffect(() => {
    console.log("entrou em courseView");
    loadDocument({
      params: {
        id,
      },
    });
    if(user){
      getListJustify();
      // if (isEditor()||isDeped()){
      //   listSubscribe({
      //     params: {
      //       id,
      //     },
      //   });
      // }
      loadRights({
        params:{
          id,
        }
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(documento.subscriptionEnabled){
      if(!(isAfter(new Date(), new Date(parseInt(documento.subscriptionEnd)))) && !(isBefore(new Date(), new Date(parseInt(documento.subscriptionBegin))))){
        setSubscriptionText("Fazer inscrição");
      }
      else{
        setSubscriptionText("Inscrição indisponível");  
      }
    }
    else{
      setSubscriptionText("Inscrição indisponível");
      if(documento.idUserSubscription){
        if(isAfter(new Date(), new Date(parseInt(documento.subscriptionEnd)))){
          setSubscriptionText("Inscrito");
        }
        else{
          setSubscriptionText("Excluir inscrição");
        }
      }
    }
  }, [documento]);

  useEffect(() => {
    console.log("ModalDeleteFile",ModalDeleteFile);
  }, [ModalDeleteFile]);

  const getDescriptionJustify = (id) => {
    return listJustify.find((justify)=>{return justify.idactivities_justifications===id})?.description;
  };

  // const handleDownload = () => {
  //   let maxWidth = [
  //     5,
  //     10,
  //     15,
  //     10,
  //     10,
  //     10
  //   ]

  //   listInfoSubscribe.map((sub,index)=>{
  //     if(sub.RGF?.length>maxWidth[0])maxWidth[0]=sub.RGF.length;
  //     if(sub.Nome?.length>maxWidth[1])maxWidth[1]=sub.Nome.length;
  //     if(sub.CPF?.length>maxWidth[2])maxWidth[2]=sub.CPF.length;
  //     if(sub.email?.length>maxWidth[3])maxWidth[3]=sub.email.length;
  //     if(sub.Escola?.length>maxWidth[4])maxWidth[4]=sub.Escola.length;
  //     if(sub.Classe?.length>maxWidth[5])maxWidth[5]=sub.Classe.length;
  //   });

  //   // create workbook and worksheet
  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.table_to_sheet(document.getElementById("tableCourses"));
  //   maxWidth.forEach((width)=>{worksheet['!cols'].push({ wch: width+2 })});
  //   console.log(worksheet);

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

  //   XLSX.writeFile(workbook, `${documento.title.trim()}.xlsx`, { compression: true });
  // };

  return (
    <Container>
      {(loadDocumentInfo.loading || 
       ListActivitiesInfo.loading ||
       UnsubscribeInfo.loading ||
      //  ListSubscribeInfo.loading ||
       LoadListUserActivitiesInfo.loading ||
       getListJustifyInfo.loading ||
       loadRightsInfo.loading) && <FullScreenLoading />}
      <Accessibility />
      <Menu />
      <Banner
        icon={images.iconDocumentos}
        url={`/formacoes/editar/${documento?.id}`}
        editorId={"0e3b686a-9b75-4de0-a2b7-28ec578e8119"}
      >
        {documento.title && ellipsis(documento.title, 20)}
      </Banner>
      <ContentBox>
        <Title>{documento.title}</Title>
        <Description>{documento.description}</Description>
        <Teacher>
          <p>
            <b>Formador: </b>
            {documento.teacher}{" "}
            {documento.teacherContact && `(${documento.teacherContact})`}
          </p>
          {(isEditor()||isDeped()) && <p>{documento.tutor && <><b>Tutor da formação:</b> {documento.tutor}</>}</p>}
        </Teacher>
        <Documents>
          {documento.documents?.map((d, n) => (
            <span key={n}>
              <a
                href={`${process.env.REACT_APP_CDN_URL}/canalPedagogico/course/${d.url}`}
                target="_blank"
                rel="noreferrer"
              >
                {d.originalName || `Documento ${n + 1}`}
              </a>
            </span>
          ))}
        </Documents>
        <Meetings>
          <b>
            {documento.meetings?.length}
            {documento.meetings?.length > 0 && documento.meetings?.length === 1
              ? " Encontro:"
              : " Encontros:"}
          </b>
          {documento.meetings?.map((e, i) => (
            <div key={i}>
              {'\u25CF'}<span>
                {
                (e.place.indexOf("http") !== -1) ? (<Link to={e.place}> {e.place}</Link>) : ` ${e.place}`} - {" "}
                {format(parseInt(e.eventDate), "dd/MM/yyyy", {
                  locale: ptBR,
                })}
                {" das "}
                {format(parseInt(e.eventBegin), "HH'h'mm", {
                  locale: ptBR,
                })}
                {" às "}
                {format(parseInt(e.eventEnd), "HH'h'mm", {
                  locale: ptBR,
                })}
                {format(parseInt(e.eventDate), " (EEEE)", {
                  locale: ptBR,
                })}
              </span>
            </div>
          ))}
        </Meetings>
        <div>
          Período de Inscrição:{" "}
                {documento?.subscriptionBegin && format(new Date(parseInt(documento.subscriptionBegin)), "dd/MM/yyyy", {
                  locale: ptBR,
                })}
                {" - "}
                {documento?.subscriptionEnd && format(new Date(parseInt(documento.subscriptionEnd)), "dd/MM/yyyy", {
                  locale: ptBR,
                })}
        </div>

        <div>
          {documento.hasSubscription && <span>Vagas: {`${(documento.subscriptionsLimit-documento.totalSubscriptions)<0?0:documento.subscriptionsLimit-documento.totalSubscriptions}/${documento.subscriptionsLimit} atualizado em: ${documento.dateSearch}`}</span>}
        </div>

        {/* Informações das incrições */}
        
        {documento.idUserSubscription && <InfoSubs>
                <InfoSubsTitle>Informações da Incrição</InfoSubsTitle>
                {documento.rgf && <div>Inscrito com o RGF:{documento.rgf}</div>}
                <div>Este curso {!documento.htpf && "não"} gera horas para HTPF {documento.htpf && "que será computado pelo Departamento Pedagógico!"}</div>
              </InfoSubs>}

        {/* {(isEditor()||isDeped()) && <Table id="tableCourses">
            <thead>
              <tr><th colSpan="6">{documento.title}</th></tr>
              <tr>
                <th>RGF</th>
                <th>Nome</th>
                <th className='cpfClass'>CPF</th>
                <th className='emailClass'>E-mail</th>
                <th>Escola</th>
                <th className='classeClass'>Turma</th>
              </tr>
            </thead>
            <tbody>
              {listInfoSubscribe.map((sub,index)=>(<tr key={index}>
                <td>{sub.RGF}</td>
                <td>{sub.Nome}</td>
                <td>{sub.CPF}</td>
                <td>{sub.email && sub.email}</td>
                <td>{sub.Escola}</td>
                <td>{sub.Classe}</td>
              </tr>))}
            </tbody>
          </Table>}

          {(isEditor()||isDeped()) && <ReadMoreButton onClick={handleDownload} text="Download xlsx" />} */}

          {/* Area de atividades */}

          {<>
            {((activitiesRights.tutor || activitiesRights.inscrito) && documento.classroomUrl) &&
              <ListItem
                visible={true} 
                row={true}
              >
                {documento.useGoogleClassroom!==false && documento.classroomUserId!==null && <a href={documento.classroomUrl} target="_blank" rel="noreferrer"><ReadMoreButton text="Acessar Google Classroom"/></a>}
                {documento.useGoogleClassroom!==false && documento.classroomUserId===null && documento.classroomInvitationId !== null && <p>O E-mail de convite para o Classroom já foi enviado para o seu email. Aceite o convite para liberar o acesso ao Classroom da formação.</p>}
                {documento.useGoogleClassroom!==false && documento.classroomUserId===null && documento.classroomInvitationId === null && <p>Aguarde o envio do convite para acesso ao Classroom, se já faz mais de um dia que fez a inscrição e o convite não foi enviado, entre em contato com o Canal Pedagógico: 
                canalpedagogico@se-pmmc.com.br</p>}
              </ListItem>}
            {activitiesRights.inscrito && activities.length>0 && <>
              <ListItem 
                visible={true} 
                border={true}
                roundborder={true} 
                row={true}
                selected={activityOpen}
                onClick={()=>{setActivityOpen(!activityOpen)}}>
                Atividades
                {activityOpen?<MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
              </ListItem>

              <ListItem 
                    marTop={0.01} 
                    row = {true}
                    justify={"space-between"}
                    reduct={5}
                    padW={2}
                    visible={activityOpen}>
                  <ListItem 
                      marTop={0.01} 
                      justify={"flex-start"}
                      align={"flex-start"}
                      reduct={31}
                      visible={activityOpen}>
                    <p>Carga Horária Total: {getHourActivity(documento.courseWorkload)}</p>
                    <p>Carga Horaria Realizada: {getHourActivity(workload)}</p>
                    {documento.htpf && <p>Abonadas (HTPF): {getHourActivity(abonadas)}:</p>}
                    {documento.htpf ? 
                      <p>O HTPF desta formação será registrado no SGE pelo DEPED.</p>:
                      documento.htpf===false && <p>O HTPF desta formação não será registrado no SGE pelo DEPED.</p>
                    }
                  </ListItem>
                  <ListItem reduct={70}
                            row={true}
                            marTop={0.01} 
                            justify={"space-between"}
                            visible={true}>
                      <Legend><img src={icons.atividade_feito} alt="Concluído"/>Concluído</Legend>
                      <Legend><img src={icons.atividade_falta} alt="Não concluído"/>Não concluído</Legend>
                      <Legend><img src={icons.atividade_justificado} alt="Justificado"/>Justificado</Legend>
                  </ListItem>
              </ListItem>

              {
                listModule.length>1 && <>
                  {listModule.map((module)=><ListItem 
                                              marTop={0.01} 
                                              row={true}
                                              visible={activityOpen?(openModule!==null?openModule===module:activityOpen):false}
                                              selected={openModule===module}
                                              border={true}
                                              roundborder={true} 
                                              onClick={()=>{setOpenModule(openModule!==null?null:module)}}
                                            >
                    {module===0?`Orientações`:`Modulo ${module}`} {openModule===module?<MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
                  </ListItem>)}
                </>
              }

              {listUserActivities.filter((activity)=>{return activity.module===openModule}).map((activity)=>(<Module visible={openModule!==null}>
                {(isAfter(new Date(parseInt(activity.activityBegin)),new Date())===false) && <ListItem visible={activityOpen} reduct={5} row={true} justify={"flex-start"} border={true} >
                  <ListItem visible={activityOpen} align={"flex-start"} padW={2} reduct={21}>
                    {activity.module!==null && <div>{activity.module===0?"Módulo único":`Módulo: ${activity.module}` }<br/></div>}
                    <div>{activity.title}</div>
                    <div>
                      {textToVectorIsLink(activity.description).map((desc,index)=>desc.isLink?
                        <a href={desc.text} key={index} target="_blank" rel="noreferrer">
                          {desc.text}
                        </a>:desc.text)}
                    </div>
                    {activity.documents?.length>0 && <><div>Documentos:</div>
                    <DocumentsMABox>
                      {activity.documents?.map((document)=>(
                        <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/activities/${document.url}`} target="_blank" rel="noreferrer">
                          <div>
                            {document.originalName} 
                            <span><IoMdDownload /></span>
                          </div>
                        </a>
                      ))}
                    </DocumentsMABox></>}
                    <div>Carga Horária: {activity.activityWorkload}:00</div>
                    <div>Periodo:
                      {format(new Date(parseInt(activity.activityBegin)), "dd/MM/yyyy", {locale: ptBR,})}
                      -
                      {format(new Date(parseInt(activity.activityEnd)), "dd/MM/yyyy", {locale: ptBR,})}
                    </div>
                    {
                      activity.userActivity.documentUrl && <>
                        <div>{activity.userActivity.isJustification?"Justificativa de ausência:":"Arquivo enviado:"}</div>
                        <DocumentsMABox>
                          <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${activity.userActivity.documentUrl}`} target="_blank" rel="noreferrer">
                            <div>
                              {activity.userActivity.documentName} 
                              <span><IoMdDownload /></span>
                            </div>
                          </a>
                        </DocumentsMABox>
                        {activity.userActivity.tutor_message && 
                          <div>
                            <p>Mensagem do tutor:</p> 
                            {textToVectorIsLink(activity.userActivity.tutor_message).map((desc,index)=>desc.isLink?
                              <a href={desc.text} key={index} target="_blank" rel="noreferrer">
                                {desc.text}
                              </a>:desc.text)}
                          </div>}
                      </>
                    }
                    {
                      activity.userActivity.activity_score && <>
                        <div>Horas Cumpridas: {getHourActivity(activity.userActivity.activity_score)}</div>
                      </>
                    }
                  </ListItem>
                  <ListItem visible={activityOpen} reduct={80} padV={0} gap={true}>
                    {activity.hours_taken===0 && <IconBox><img src={icons.atividade_falta} alt=""/></IconBox>}
                    {activity.hours_taken===1 && <IconBox><img src={icons.atividade_feito} alt=""/></IconBox>}
                    {activity.hours_taken===2 && <IconBox><img src={icons.atividade_justificado} alt=""/></IconBox>}
                    {activity.hours_taken===2 && <Justify>{getDescriptionJustify(activity.idactivities_justifications)}</Justify>}
                    {activity.classroomActivityUrl && <a href={activity.classroomActivityUrl} target="_blank" rel="noreferrer"><ReadMoreButton text="Acessar Atividade"/></a>}
                    {((activity.classroomActivityType==="FORMULÁRIO DE AVALIAÇÃO")&&(activity?.formDetails?.responseUrl)) && <a href={activity?.formDetails?.responseUrl} target="_blank" rel="noreferrer"><ReadMoreButton text="Acessar Formulário"/></a>}
                    {(
                      (isBefore(new Date(),new Date(parseInt(activity.activityEnd))))
                      &&(activity.classroomActivityType==="REGISTRO DE PRESENÇA")
                      &&activity.activityWorkload!==0
                      &&activity.hours_taken!==0
                      &&activity.hours_taken!==1
                      &&activity.hours_taken!==2)
                      && <ReadMoreButton text={"Abrir codigo QR"} onClick={()=>{setModalQRRegistro(activity.idContentActivity)}}/>}
                    {(
                      (isWithinInterval(new Date(),{start:new Date(parseInt(activity.activityBegin)),end:new Date(parseInt(activity.activityEnd))}))
                      &&(activity.classroomActivityType==="PORTFÓLIO")
                      &&activity.activityWorkload!==0
                      &&activity.hours_taken!==0
                      &&activity.hours_taken!==1
                      &&activity.hours_taken!==2
                      &&((activity.userActivity.documentUrl?(activity.userActivity.documentUrl&&activity.userActivity.isJustification===false):true))) 
                      && <InputFile
                            accept="application/pdf,image/*"
                            id={`portfólio-${activity.idContentActivity}`}
                            text={`${activity.userActivity.documentUrl?"Atualizar Arquivo":"Enviar Arquivo"}`}
                            value={activity.userActivity.documentUrl===null?"":""}
                            onChange={(event)=>{setModalSendFile({open:true,type:"ATIVIDADE",data:{file:event.target.files[0],idContentActivity:activity.idContentActivity,update:activity.userActivity.documentUrl?true:false}})}}
                         />}
                    {(
                      (isAfter(new Date(),new Date(parseInt(activity.activityBegin))))
                      &&activity.activityWorkload!==0
                      &&activity.hours_taken!==1
                      &&activity.hours_taken!==2
                      &&((activity.userActivity.documentUrl?(activity.userActivity.documentUrl&&activity.userActivity.isJustification===true):true))) 
                      && <InputFile
                            accept="application/pdf,image/*"
                            id={`justificativa-${activity.idContentActivity}`}
                            text={`${activity.userActivity.documentUrl?"Atualizar Justificativa":"Enviar Justificativa"}`}
                            value={activity.userActivity.documentUrl===null?"":""}
                            onChange={(event)=>{setModalSendFile({open:true,type:"JUSTIFICATIVA DE AUSÊNCIA",data:{file:event.target.files[0],idContentActivity:activity.idContentActivity,update:activity.userActivity.documentUrl?true:false}})}}
                         />}
                    {(
                      (activity.userActivity.documentUrl)&&
                      (activity.hours_taken!==2&&activity.userActivity.isJustification)
                      )&& <CancelButton
                            text="Excluir Justificativa"
                            onClick={()=>{setModalDeleteFile({open:true,type:"Justificativa",file:activity.userActivity.idcontent_activity})}}
                         />}
                    {(
                      (activity.userActivity.documentUrl)&&
                      (activity.hours_taken!==2&&activity.hours_taken!==1&&activity.userActivity.isJustification===false)&&
                      (isWithinInterval(new Date(),{start:new Date(parseInt(activity.activityBegin)),end:new Date(parseInt(activity.activityEnd))}))
                      )&& <CancelButton
                            text="Excluir Arquivo"
                            onClick={()=>{setModalDeleteFile({open:true,type:"Arquivo",file:activity.userActivity.idcontent_activity})}}
                         />}
                    
                  </ListItem>
                </ListItem>}
              </Module>))}

              {/* {activities.length>0 && <ListItem visible={activityOpen} row={true} justify={"flex-end"}>
                <Legend><img src={icons.atividade_feito}/>Presente</Legend>
                <Legend><img src={icons.atividade_falta}/>Falta</Legend>
                <Legend><img src={icons.atividade_justificado}/>Justificada</Legend>
              </ListItem>} */}
              
            </>}
          </>}

          {/* Area de atividades fim */}
        
        {isEditor() && documento.visibilities?.length>0 && (
          <Visibility visibility={documento.visibilities} align="center" />
        )}
        
        <BoxButtons>
          {documento.hasSubscription && (activitiesRights.tutor || activitiesRights.editor) && <ReadMoreButton onClick={()=>{navigate(`/coursemanager/${id}`)}} text="Gerenciamento do Curso" />}

          <CancelButton
            text="Voltar"
            onClick={() => {
              navigate(-1);
           }}
          />

          {(user && !(isEditor()) && documento.hasSubscription) && <ReadMoreButton onClick={handleSubscription} text={subscriptionText} alert={subscriptionText==="Inscrição indisponível"}/>}
        </BoxButtons>
        <Modal  open={ModalOpenAlert} close={handleModalAlert} buttonClose = {false} width={50} height={15}>
          <Message>
            <div>{documento.subscriptionStatusMessage}</div>
            <ReadMoreButton onClick={handleModalAlert} text="Ok" />
          </Message>
        </Modal>
        <Modal  open={ModalOpenUnsubscribe} close={handleModalUnsubscribe} buttonClose = {false} width={100} height={15}>
          <Message>
            <div>Deseja mesmo cancelar sua inscrição em: {documento.title} ?</div>
            <div>
              <ReadMoreButton text="SIM" onClick={handleUnsubscribe}/>
              <ReadMoreButton text="NÃO" onClick={handleModalUnsubscribe}/>
            </div>
          </Message>
        </Modal>
        <Modal  open={ModalOpenAlertUnsubscribe} close={handleModalAlertUnsubscribe} buttonClose = {false} width={50} height={15}>
          <Message>
            <div>{unsubscriptionStatusMessage}</div>
            <ReadMoreButton onClick={handleAlertUnsubscribeOk} text="Ok" />
          </Message>
        </Modal>
        <Modal open={modalMessage.open} buttonClose={false}>
          <div>{modalMessage.text}</div>
          <ReadMoreButton
              text="Ok"
              type="button"
              onClick={()=>{setModalMessage({open:false,text:""})}}
          />
        </Modal>
        <Modal  open={ModalDeleteFile.open} buttonClose = {false} width={100} height={15}>
          <Message>
            <div>Deseja mesmo deletar {ModalDeleteFile.type==="Arquivo"?"seu arquivo?":""} {ModalDeleteFile.type==="Justificativa"?"sua Justificativa?":""}</div>
            <div>
              <ReadMoreButton text="SIM" onClick={()=>{
                setModalDeleteFile({open:false,type:"",file:""});
                deleteFile({
                  data: {
                    idContentActivity:ModalDeleteFile.file,
                    isJustification:ModalDeleteFile.type!=="Arquivo"
                  },});
                }}/>
              <ReadMoreButton text="NÃO" onClick={()=>{setModalDeleteFile({open:false,type:"",file:""})}}/>
            </div>
          </Message>
        </Modal>
        <Modal  open={modalSendFile.open} buttonClose = {false} width={100} height={15}>
          <Message>
            <ConfirmFile>Confirma o envio de {modalSendFile.type}?</ConfirmFile>
            <div>
              <ReadMoreButton text={`Enviar Arquivo`} onClick={()=>{
                  if(modalSendFile.type==="ATIVIDADE"){
                    handleAttachFilesPortfolio(modalSendFile.data.file,modalSendFile.data.idContentActivity,modalSendFile.data.update);
                  }
                  if(modalSendFile.type==="JUSTIFICATIVA DE AUSÊNCIA"){
                    handleAttachFilesJustificativa(modalSendFile.data.file,modalSendFile.data.idContentActivity,modalSendFile.data.update);
                  }
                  setModalSendFile({open:false,type:"",event:{}});
                }}/>
              <ReadMoreButton text="Cancelar" onClick={()=>{setModalSendFile({open:false,type:"",event:{}})}}/>
            </div>
          </Message>
        </Modal>
        <Modal  open={modalQRRegistro!==""} buttonClose = {false} width={100} height={15}>
          <QRCode dados={{idUserSubscription:documento.idUserSubscription,course:id,activity:modalQRRegistro}} title={`${documento.title}`}/>
          <ReadMoreButton text="Fechar" onClick={()=>{setModalQRRegistro("")}}/>
        </Modal>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default CoursesView;
